// Fixed top nav — frosted once the page is scrolled past the hero's edge.
export function initNav(): void {
  const nav = document.querySelector<HTMLElement>('[data-nav]');
  if (!nav) return;

  const onScroll = (): void => {
    nav.classList.toggle('is-scrolled', (window.scrollY || 0) > 40);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}
